import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=7c13b81c&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c13b81c')) {
      api.createRecord('7c13b81c', component.options)
    } else {
      api.reload('7c13b81c', component.options)
    }
    module.hot.accept("./dispatch.vue?vue&type=template&id=7c13b81c&", function () {
      api.rerender('7c13b81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/complaintQuery/dispatch.vue"
export default component.exports